// @flow
import React from 'react';
// Styles
import './FormControlInput.css';

type Props = {
  value: string | number,
  type?: string,
  label?: string,
  componentLabel?: React$Node,
  errorMessage?: string,
  handleChangeText: (value: string | number) => void,
  handleBlur?: () => void,
  handleFocus?: () => void,
  isRequired?: boolean,
  maxLength?: string | number,
  disabled?: boolean,
  autocomplete: string,
  variant: 'rounded' | 'default',
  readonly?: boolean,
};

const FormControlInput = ({
  type = 'text',
  value = '',
  label,
  errorMessage = 'Esse campo é obrigatório*',
  handleChangeText,
  handleBlur,
  handleFocus,
  isRequired = false,
  maxLength,
  disabled,
  autocomplete,
  variant = 'default',
  readonly = false,
  componentLabel,
}: Props) => {
  return (
    <div className="form-control-input-wrapper">
      {componentLabel ? (
        <div className="form-control-input-component-label">
          {componentLabel}
        </div>
      ) : (
        <label className="input-with-address-autocomplete-label">
          {label}
          {isRequired && <span className="form-control-input-required">*</span>}
        </label>
      )}

      <input
        className={`form-control-input ${
          errorMessage && variant === 'default'
            ? 'form-control-input-invalid'
            : ''
        } ${variant === 'rounded' ? 'form-control-input-rounded' : ''} ${
          errorMessage && variant === 'rounded'
            ? 'form-control-input-rounded-invalid'
            : ''
        }`}
        type={type}
        value={value}
        required={isRequired}
        autoComplete={autocomplete}
        name={label}
        id={label}
        placeholder={label}
        onChange={event => handleChangeText(event.target.value)}
        onBlur={handleBlur}
        onFocus={event => {
          handleFocus?.(event.target.value);
        }}
        maxLength={maxLength}
        disabled={disabled}
        readOnly={readonly}
      />
      {!!errorMessage && (
        <span className="form-control-input-message form-control-input-message-animation">
          {errorMessage}
        </span>
      )}
    </div>
  );
};

export default FormControlInput;
